import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Send lead to call center (Waypoint Software)
// Only called when revenue < 2 and not a duplicate
export async function sendToCallCenter({ firstname, lastname, phone, city, state, zip, email }) {
  const url = ENDPOINTS.CALL_CENTER +
    '?xAuthentication=8ac67eabf731769da3eed05640fb1c87' +
    `&firstname=${encodeURIComponent(firstname)}` +
    `&lastname=${encodeURIComponent(lastname)}` +
    `&phone1=1${encodeURIComponent(phone)}` +
    `&city=${encodeURIComponent(city)}` +
    `&state=${encodeURIComponent(state)}` +
    `&zip=${encodeURIComponent(zip)}` +
    `&email=${encodeURIComponent(email)}`

  try {
    const response = await axios.get(url, { maxBodyLength: Infinity })
    console.log('Call center response:', response.data)
    return response.data
  } catch (error) {
    console.error('Call center error:', error)
    return null
  }
}

// Check if we should send to call center
export function shouldSendToCallCenter(revenue, result) {
  // Don't send if revenue is >= 2
  if (revenue >= 2) return false

  // Don't send if duplicate
  if (String(result).toLowerCase() === 'duplicate') return false

  return true
}

export const callCenterService = {
  sendToCallCenter,
  shouldSendToCallCenter
}
